import { createSlice } from '@reduxjs/toolkit'

export const bitcoinSlice = createSlice({
  name: 'bitcoin',
  initialState: {
    address: '',
    amount: '',
    item: '',
    message: ''
  },
  reducers: {
    setBitcoinField(state, action) {
      state[action.payload.key] = action.payload.val
    },
    initializeBitcoin(state, action) {
      state.address = ''
      state.amount = ''
      state.item = ''
      state.message = ''
    }
  }
})

export const {
  setBitcoinField,
  initializeBitcoin
} = bitcoinSlice.actions
export default bitcoinSlice.reducer